var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgStep2 = function SvgStep2(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50pt",
    height: "50pt",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 107.5,
    y1: 27.882811,
    x2: 107.5,
    y2: 33.940441,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(98.431373%,91.37255%,77.64706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(100%,72.941178%,37.254903%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 63.15625,
    y1: 27.882811,
    x2: 63.15625,
    y2: 33.940441,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(98.431373%,91.37255%,77.64706%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(100%,72.941178%,37.254903%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear2",
    gradientUnits: "userSpaceOnUse",
    x1: 86,
    y1: 12.98869,
    x2: 86,
    y2: 159.938507,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(96.078432%,75.686276%,36.078432%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(93.333334%,52.941179%,0%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear3",
    gradientUnits: "userSpaceOnUse",
    x1: 86,
    y1: 12.98869,
    x2: 86,
    y2: 159.938507,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(96.078432%,75.686276%,36.078432%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(93.333334%,52.941179%,0%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear4",
    gradientUnits: "userSpaceOnUse",
    x1: 102.125,
    y1: 12.98869,
    x2: 102.125,
    y2: 159.938507,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(96.078432%,75.686276%,36.078432%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(93.333334%,52.941179%,0%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear5",
    gradientUnits: "userSpaceOnUse",
    x1: 68.53125,
    y1: 12.98869,
    x2: 68.53125,
    y2: 159.938507,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(96.078432%,75.686276%,36.078432%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(93.333334%,52.941179%,0%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface9287899"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 28.90625 8.59375 L 33.59375 8.59375 L 33.59375 9.375 L 28.90625 9.375 Z M 28.90625 8.59375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear1)"
    },
    d: "M 15.625 8.59375 L 21.09375 8.59375 L 21.09375 9.375 L 15.625 9.375 Z M 15.625 8.59375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear2)"
    },
    d: "M 37.5 9.375 L 35.15625 9.375 L 35.15625 8.59375 C 35.15625 7.730469 34.457031 7.03125 33.59375 7.03125 L 28.574219 7.03125 C 27.96875 5.652344 26.597656 4.6875 25 4.6875 C 23.402344 4.6875 22.03125 5.652344 21.425781 7.03125 L 15.625 7.03125 C 14.761719 7.03125 14.0625 7.730469 14.0625 8.59375 L 14.0625 9.375 L 12.5 9.375 C 10.777344 9.375 9.375 10.777344 9.375 12.5 L 9.375 42.1875 C 9.375 43.910156 10.777344 45.3125 12.5 45.3125 L 37.5 45.3125 C 39.222656 45.3125 40.625 43.910156 40.625 42.1875 L 40.625 12.5 C 40.625 10.777344 39.222656 9.375 37.5 9.375 Z M 33.59375 8.59375 L 33.59375 9.375 L 28.90625 9.375 L 28.90625 8.59375 Z M 22.65625 8.59375 C 22.65625 7.300781 23.707031 6.25 25 6.25 C 26.292969 6.25 27.34375 7.300781 27.34375 8.59375 L 27.34375 14.0625 L 22.65625 14.0625 Z M 22.65625 15.625 L 27.34375 15.625 C 28.207031 15.625 28.90625 14.925781 28.90625 14.0625 L 35.9375 14.0625 L 35.9375 37.5 L 14.0625 37.5 L 14.0625 14.0625 L 21.09375 14.0625 C 21.09375 14.925781 21.792969 15.625 22.65625 15.625 Z M 14.0625 39.0625 L 35.9375 39.0625 L 35.9375 40.625 L 14.0625 40.625 Z M 15.625 8.59375 L 21.09375 8.59375 L 21.09375 9.375 L 15.625 9.375 Z M 39.0625 42.1875 C 39.0625 43.050781 38.363281 43.75 37.5 43.75 L 12.5 43.75 C 11.636719 43.75 10.9375 43.050781 10.9375 42.1875 L 10.9375 12.5 C 10.9375 11.636719 11.636719 10.9375 12.5 10.9375 L 21.09375 10.9375 L 21.09375 12.5 L 14.0625 12.5 C 13.199219 12.5 12.5 13.199219 12.5 14.0625 L 12.5 40.625 C 12.5 41.488281 13.199219 42.1875 14.0625 42.1875 L 35.9375 42.1875 C 36.800781 42.1875 37.5 41.488281 37.5 40.625 L 37.5 14.0625 C 37.5 13.199219 36.800781 12.5 35.9375 12.5 L 28.90625 12.5 L 28.90625 10.9375 L 37.5 10.9375 C 38.363281 10.9375 39.0625 11.636719 39.0625 12.5 Z M 39.0625 42.1875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear3)"
    },
    d: "M 27.628906 28.125 L 21.09375 28.125 C 19.800781 28.125 18.75 29.175781 18.75 30.46875 L 18.75 31.394531 C 17.84375 31.71875 17.1875 32.578125 17.1875 33.59375 C 17.1875 34.886719 18.238281 35.9375 19.53125 35.9375 C 20.824219 35.9375 21.875 34.886719 21.875 33.59375 C 21.875 32.578125 21.21875 31.71875 20.3125 31.394531 L 20.3125 30.46875 C 20.3125 30.039062 20.664062 29.6875 21.09375 29.6875 L 27.628906 29.6875 C 28.859375 29.6875 29.6875 28.746094 29.6875 27.34375 L 29.6875 25 L 31.597656 25 C 32.074219 25 32.476562 24.789062 32.679688 24.433594 C 32.871094 24.101562 32.855469 23.707031 32.636719 23.339844 L 30.320312 19.574219 C 30.019531 19.066406 29.464844 18.75 28.871094 18.75 C 28.296875 18.75 27.78125 19.039062 27.496094 19.519531 L 25.167969 23.371094 C 24.957031 23.726562 24.945312 24.117188 25.128906 24.441406 C 25.332031 24.796875 25.726562 25 26.214844 25 L 28.125 25 L 28.125 27.34375 C 28.125 27.863281 27.957031 28.125 27.628906 28.125 Z M 19.53125 34.375 C 19.101562 34.375 18.75 34.023438 18.75 33.59375 C 18.75 33.164062 19.101562 32.8125 19.53125 32.8125 C 19.960938 32.8125 20.3125 33.164062 20.3125 33.59375 C 20.3125 34.023438 19.960938 34.375 19.53125 34.375 Z M 31.597656 23.4375 C 31.597656 23.4375 31.601562 23.4375 31.601562 23.4375 L 31.597656 24.21875 Z M 28.902344 20.316406 C 28.921875 20.320312 28.953125 20.335938 28.980469 20.378906 L 30.863281 23.4375 L 26.964844 23.4375 Z M 28.902344 20.316406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear4)"
    },
    d: "M 31.25 31.25 L 28.125 31.25 C 27.261719 31.25 26.5625 31.949219 26.5625 32.8125 L 26.5625 34.375 C 26.5625 35.238281 27.261719 35.9375 28.125 35.9375 L 31.25 35.9375 C 32.113281 35.9375 32.8125 35.238281 32.8125 34.375 L 32.8125 32.8125 C 32.8125 31.949219 32.113281 31.25 31.25 31.25 Z M 31.25 34.375 L 28.125 34.375 L 28.125 32.8125 L 31.25 32.8125 Z M 31.25 34.375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear5)"
    },
    d: "M 18.75 18.75 C 17.886719 18.75 17.1875 19.449219 17.1875 20.3125 L 17.1875 21.875 C 17.1875 22.738281 17.886719 23.4375 18.75 23.4375 L 21.09375 23.4375 C 21.957031 23.4375 22.65625 22.738281 22.65625 21.875 L 22.65625 20.3125 C 22.65625 19.449219 21.957031 18.75 21.09375 18.75 Z M 21.09375 21.875 L 18.75 21.875 L 18.75 20.3125 L 21.09375 20.3125 Z M 21.09375 21.875 "
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStep2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/step2.c6fd99f0.svg";
export { ForwardRef as ReactComponent };